<template>
    <div>
        <div v-show="pagination.totalPages > 1">
            <button :class="{tiny: true, loading: buttonsLoading}" @click="goPrevPage" :disabled="isPrevDisabled">
                <i class="fa fa-arrow-left"></i> пред
            </button>

            <span v-for="row in paginationNumbers">
                <button v-if="row.text !== '...'"
                        :class="{tiny: true, black: row.value == pagination.currentPage, loading: buttonsLoading}"
                        @click="setPageSelect(row.value)"
                >
                    {{ row.text }}
                </button>
                <select v-if="row.text === '...'"
                        v-model="pageSelected"
                        :class="{'tiny button': true, blue: row.value == pagination.currentPage, loading: buttonsLoading}"
                >
                    <option disabled value="">.......</option>
                    <option v-for="option in row.value" :value="option.value">{{ option.text }}</option>
                </select>
            <!-- -->
            </span>

            <button :class="{tiny: true, loading: buttonsLoading}" @click="goNextPage" :disabled="isNextDisabled">
                след <i class="fa fa-arrow-right"></i>
            </button>
        </div>

        <div v-show="pagination.totalPages <= 1">
            <button :class="{tiny: true, loading: buttonsLoading}" disabled><i class="fa fa-arrow-left"></i> пред</button>
            <button :class="{tiny: true, loading: buttonsLoading}" @click="setPageSelect(1)">1</button>
            <button :class="{tiny: true, loading: buttonsLoading}" disabled>след <i class="fa fa-arrow-right"></i></button>
        </div>
    </div>
</template>

<script>
import {range} from "lodash/util";

export default {
  name: "DoctuTableEagerPagination",
  model: {
    prop: 'pagination',
    event: 'input'
  },
  props: {
    pagination: {
      required: true,
    },
    rowscount: {
      default: 0
    },
    pagesmax: {
      default: 11
    }
  },
  data: function () {
    return {
      pageSelected: '',
      disableButtons: false,
      buttonsLoading: false,
    }
  },
  computed: {
    isNextDisabled: function () {
      if (this.disableButtons) {
        return true;
      }
      return !this.pagination.totalPages
          || (this.pagination.totalPages <= this.pagination.currentPage);
    },
    isPrevDisabled: function () {
      return this.pagination.currentPage === 1 || this.disableButtons;
    },
    paginationNumbers: function () {
      let result = [];
      try {
        if (this.pagination.totalPages === 1) {
            return [{text: 1, value: 1}];
        }

        if (this.pagination.totalPages <= this.pagesmax) {
            for (let page = 1; page <= this.pagination.totalPages; page++) {
              result.push({text: page, value: page});
            }
            return result;
        }

        let halfOfMaxpages = Math.ceil(this.pagesmax / 2)
        let currentPageOnBeginning = this.pagination.currentPage <= halfOfMaxpages;
        let currentPageOnEnding = this.pagination.currentPage > (this.pagination.totalPages - halfOfMaxpages);

        if (currentPageOnBeginning) {
            for (let page = 1; page <= Math.min(this.pagesmax, this.pagination.totalPages); page++) {
                result.push({text: page, value: page});
            }
        } else if (currentPageOnEnding) {
            let start = Math.min(this.pagination.currentPage - halfOfMaxpages, this.pagination.totalPages - this.pagesmax) + 1;
            for (let page = start; page <= this.pagination.totalPages; page++) {
                result.push({text: page, value: page});
            }
        } else { // currentPageOnCenter
            for (let page = Math.max(this.pagination.currentPage - halfOfMaxpages + 1, 1); page <= Math.min(this.pagination.currentPage + halfOfMaxpages, this.pagination.totalPages); page++) {
                result.push({text: page, value: page});
            }
        }

        if (!result[0] || (result[0].text !== 1)) {
            result[0] = {text: 1, value: 1};
            result[1] = {text: '...', value: this.prevArrayOfPages};
        }

        if (result[result.length - 1].text !== this.pagination.totalPages) {
            result[result.length - 2] = {text: '...', value: this.nextArrayOfPages};
            result[result.length - 1] = {text: this.pagination.totalPages, value: this.pagination.totalPages};
        }

        return result;

      } catch (e) {
        return [];
      }
    },
    prevArrayOfPages() {
        const countButtonBeforeSelected = 3;

        return range(
            Math.max(1, this.pagination.currentPage - 100 - countButtonBeforeSelected - 1),
            this.pagination.currentPage
        ).map((value) => {
            if (
                this.pagination.currentPage - value > countButtonBeforeSelected
                && value !== Math.max(1, this.pagination.currentPage - 100 - countButtonBeforeSelected - 1)
                && !this.paginationNumbers.find(item => item.value === value)
            ) {
                return {
                    text: value,
                    value: value,
                }
            }
        }).filter(n => n);
    },
    nextArrayOfPages() {
        const countButtonsAfterSelected = 4

        return range(
            this.pagination.currentPage + 1,
            Math.min(this.pagination.totalPages, this.pagination.currentPage + 105)
        ).map((value) => {
            if (
                value - this.pagination.currentPage > countButtonsAfterSelected
                && value !== this.pagination.totalPages
                && !this.paginationNumbers.find(item => item.value === value)
            ) {
                return {
                    text: value,
                    value: value,
                }
            }
        }).filter(n => n);
    },
  },
  methods: {
    goNextPage: function () {
        if (this.isNextDisabled) {
            return false;
        }
        let page = this.pagination.currentPage + 1;
        this.goPage(page);
    },

    goPrevPage: function () {
        if (this.isPrevDisabled) {
          return false;
        }
        let page = this.pagination.currentPage - 1;
        this.goPage(page);
    },
    setPageSelect(value) {
      if (value === this.pageSelected) {
        this.goPage(value);
      } else {
        this.pageSelected = value;
      }
    },

    goPage: function (page) {
        this.disableButtons = true;
        let pagination = JSON.parse(JSON.stringify(this.pagination));
        pagination.currentPage = page;
        this.$emit('input', pagination);
    },

    formPrevArray() {

    },
  },
  watch: {
    pageSelected: function (value) {
        //Событие input отправляется два раза, причем 2 раз 'undefind'
        // не смог нормально выявить где, поэтому добавляю проверку
        //TODO найти в какой момент отпраяляется второй раз
        if (value && this.pagination.currentPage !== value) {
            this.goPage(value);
        }
    }
  }
}
</script>
